<template>
  <el-dialog title="新增联系人" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="100px">
      <el-form-item label="联系人:" prop="name">
        <el-input v-model="data.name" :maxlength="32" placeholder="请输入联系人姓名" clearable/>
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerId">
        <template>
          <customer-select ref="customerSelectRef" :auth-check="true" :form-param="data" :param-list="customerList"
                           :disabled="customerDisabled" @change="customerChange"></customer-select>
        </template>
      </el-form-item>
      <el-form-item label="手机号:" prop="mobile">
        <el-input v-model="data.mobile" placeholder="请输入手机号" clearable/>
        <span slot="error" slot-scope="scope">
          <span v-if="scope.error.indexOf('#error#') > -1" class="el-form-item__error">
            已被该客户下联系人
            <el-link
              style="font-size: 12px; vertical-align: top;"
              type="primary"
              :underline="false"
              @click="toDetailBlank(scope.error.split('#error#')[0])">
              {{ scope.error.split('#error#')[1] }}
            </el-link>
            使用，请重新输入
          </span>
          <span v-else class="el-form-item__error">{{scope.error}}</span>
        </span>
      </el-form-item>
      <el-form-item label="部门:" prop="apartment">
        <el-input v-model="data.apartment" :maxlength="32" placeholder="请输入部门" clearable/>
      </el-form-item>
      <el-form-item label="职务:" prop="position">
        <el-input v-model="data.position" :maxlength="32" placeholder="请输入职务" clearable/>
      </el-form-item>
      <el-form-item label="微信号:" prop="wechat">
        <el-input v-model="data.wechat" :maxlength="32" placeholder="请输入微信号" clearable/>
      </el-form-item>
      <el-form-item label="性别:" prop="sex">
        <el-select v-model="data.sex" placeholder="请选择性别" clearable style="width:100%">
          <el-option v-for="dict in sexOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="负责人:" prop="managerId">
        <UserSelect v-model="data.managerId" placeholder="请选择负责人"></UserSelect>
      </el-form-item>
      <el-form-item label="立场:" prop="standScore">
        <el-input v-model="data.standScore" :maxlength="32" placeholder="请输入立场" clearable/>
        <el-popover
          placement="top-start"
          title="立场评分标准"
          width="500"
          trigger="hover">
          <span>备注：红色字体为市场主要手段</br>
              内线（+3）</br>
              传递客户内部信息（决策流程、决策成员组及其关注点、预算等）</br>
              传递竞争对手动态情况（小组成员、关键行动、方案及报价等）并对我方敏感信息进行保密；</br>
              给出项目推进的建议<span style="color:red;">（签约的关键推动人）</span></br>
              帮助我方创造销售机会，配合我们执行销售计划</br>
              支持（+2）</br>
              愿意支持双方合作</br>
              <span style="color:red;">愿意参与活动，并作为分享嘉宾发言（包括沙龙/发布会/论坛/直播课程等）</span></br>
              主动传递我们的价值</br>
              <span style="color:red;">1、接受瑞洁特的专访且稿件在瑞洁特自媒体或环保水圈等任一渠道发表</span></br>
              <span style="color:red;">2、作为关键对接人配合瑞洁特进行案例包装</span></br>
              <span style="color:red;">3、接受瑞洁特/环保水圈参观交流接待（活动的客户方接待人)</span>
          </span>
          <el-button type="text" slot="reference">立场评分说明</el-button>
        </el-popover>
      </el-form-item>
      <el-form-item label="出生年月" prop="birthday">
        <el-date-picker v-model="data.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="电子邮箱:" prop="email">
        <el-input v-model="data.email" :maxlength="64" placeholder="请输入电子邮箱" clearable/>
      </el-form-item>
      <el-form-item label="所在区域" prop="area">
        <el-cascader v-model="data.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址:" prop="address">
        <el-input v-model="data.address" :maxlength="255" placeholder="请输入详细地址" clearable/>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" :maxlength="1000" show-word-limit v-model="data.remark" placeholder="请输入备注" clearable/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>

</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import CompanyInput from "@/views/crm/components/companyInput";
import {mapState} from 'vuex'
import {emailValid} from "@/utils/validator";
import {isPhone} from "@/utils/validate";
import {createContact, queryContactByMobileAndCustomer} from "@/api/crm/contact";
import customerSelect from "@/views/crm/components/customerSelect";
import {listAllLevelArea} from "@/api/crm/area";
import {transferCascaderOptionsForProvince} from "@/utils";

export default {
  name: "AddContactDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      customerList: [],
      customerDisabled: false,
      sexOptions: [],
      rules: {
        name: [
          {required: true, message: '请输入联系人姓名', trigger: 'change'}
        ],
        mobile: [
          {required: true, message: '请输入联系人手机号', trigger: 'change'},
          { validator: this.checkMobile, trigger: "blur" }
        ],
        managerId: [
          {required: true, type: 'number', message: '请选择负责人', trigger: 'change'}
        ],
        email: [
          {validator: emailValid, trigger: 'change'}
        ]
      },
      areaOptions: [],
      data: {
        customerId: null,
        name: null,
        apartment: null,
        position: null,
        mobile: null,
        wechat: null,
        sex: null,
        managerId: null,
        standScore: undefined,
        birthday: null,
        email: null,
        area: [],
        remark: null,
      }
    };
  },
  created() {
    this.getDicts("sys_user_sex").then(response => {
      this.sexOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    CompanyInput,
    customerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    goAddUser () {
      this.$router.push("/crm/customer/manage");
    },
    open (type, id, name) {
      if (type == 'customerId') {
        this.data.customerId = id
        this.customerDisabled = true
        this.customerList = [{id: id, customerName: name}]
      }
      this.data.managerId = this.currentUserId;
      this.visible = true
    },
    customerChange (customerId) {
      // if (customerId) {
      //   this.$refs['addForm'].validateField('mobile');
      // }
    },
    checkMobile (rule, value, callback) {
      // 非必填
      if (!value) {
        callback()
      } else if (isPhone(value)) {
        // 填了客户名称，才去校验手机号。所以需要在填写客户名称后再手动触发下手机号校验
        if (this.data.customerId) {
          queryContactByMobileAndCustomer(
            {
              mobile: value,
              customerId: this.data.customerId
            }
          ).then( response => {
            if (response.data && response.data.id) {
              callback(new Error(response.data.id + '#error#' + response.data.name))
            } else {
              callback()
            }
          }).catch(error => {
            callback()
          })
        } else {
          callback()
        }
      } else {
        callback(new Error('格式不正确'))
      }
    },
    toDetailBlank(id) {
      this.$router.push("/crm/contact/detail/" + id);
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.data.provinceCode = this.data.area && this.data.area.length > 0 ? this.data.area[0] : null
          this.data.cityCode = this.data.area && this.data.area.length > 1 ? this.data.area[1] : null
          this.data.regionCode = this.data.area && this.data.area.length > 2 ? this.data.area[2] : null
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          createContact(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("联系人新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
